import React, { ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '../atoms/Button';

interface PromptProps {
  onClick?: () => void;
  children: ReactNode;
}

const Prompt = ({ onClick, children }: PromptProps) => {
  const { t } = useTranslation(['common']);

  return (
    <>
      <Container>
        <Row>
          <Col>{children}</Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={6} md={4} lg={3}>
            <br />
            <br />
            <Button
              dark
              large
              full
              label={t('common:cta-continue')}
              onClick={onClick}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Prompt;
